import { BenchmarkResultsInputRequest } from '../../../../../../generated/model/benchmarkResultsInputRequest';

interface Option<T> {
  value: T;
  label: string;
  excludedIndicators: BenchmarkResultsInputRequest.ProfitLevelIndicatorEnum[];
}

export const adjustmentValues: Option<BenchmarkResultsInputRequest.AdjustmentsEnum>[] = [
  {
    value: 'AR',
    label: 'Accounts Receivable',
    excludedIndicators: [],
  },
  {
    value: 'AP',
    label: 'Accounts Payable',
    excludedIndicators: [],
  },
  {
    value: 'INVENTORY',
    label: 'Inventory',
    excludedIndicators: [],
  },
  {
    value: 'PPNE',
    label: 'Tangible Fixed Assets (PP&E)',
    excludedIndicators: ['GROSS_PROFIT_MARK_UP', 'GROSS_PROFIT_MARGIN'],
  },
  {
    value: 'AOA',
    label: 'Average Operating Assets',
    excludedIndicators: ['GROSS_PROFIT_MARK_UP', 'GROSS_PROFIT_MARGIN'],
  },
];
